import React, { useState, useEffect, useContext, DragEvent} from 'react';
import { Context } from '@routes/private/Editor/Context';
import { IProps, IState } from './types';
import { IElement } from '@routes/private/Editor/types';
import * as S from './styles';

const DropAreaAddIn: React.FC<IProps> = (props) => {

  const context = useContext(Context);
  const transparentBackground = context.editorStatus.exportingProperties?.tranparentBackground;
  const zoomValue = context.editorStatus.zoom.value;

  const handleDragEnter = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    let element = e.currentTarget;
    element.classList.add("dragged-over");
    e.dataTransfer.dropEffect = "move";
  };

  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  }

  const onDrop = (e: DragEvent<HTMLDivElement>, element: IElement) => {
    e.preventDefault();
    e.currentTarget.classList.remove("dragged-over");
    const stringData = e.dataTransfer.getData("text/plain");
    const data = JSON.parse(stringData);
    const rect = e.currentTarget.getBoundingClientRect();
    let coorsPercentage = {
      x: (e.clientX - rect.x) / rect.width, 
      y: (e.clientY - rect.y) / rect.height
    };
    context.onDraggingData({...data, coorsPercentage, containerId: element.id});
  };

  const dropArea = (element: IElement, index: number) => {
    return (
      <S.DropAreaContainer key={index} >
        <S.DropArea
          key={index}
          onDragEnter={handleDragEnter}
          onDragOver={handleDragOver}
          onDrop={e => onDrop(e, element)}
          role={`${element.id}`}
          style={{
            zIndex: context.editorStatus.draggingNewElement ? 4 : 0,
            left: element.attributes.x,
            top: element.attributes.y,
            width: element.attributes.width,
            height: element.attributes.height,
          }}
        />
        { transparentBackground &&
          <S.TransparentArea
            key={`${index}-transparent`}
            transparentPercentage={transparentBackground && zoomValue > 0 ? zoomValue/100 : undefined}
            style={{
              zIndex: 0,
              left: element.attributes.x,
              top: element.attributes.y,
              width: element.attributes.width,
              height: element.attributes.height,
            }}
          />
        }
      </S.DropAreaContainer>
    )
  }

  const renderDropAreas = () => {
    let dropAreas: JSX.Element[] = [];
    if (context.data[0]?.type === "Artboards") {
      props.dropAreas.forEach ((element: IElement, index: number)=>{
        dropAreas.push(dropArea(element, index));
      })
    } else if (context.data[0]) {
      dropAreas.push(dropArea(context.data[0], 0));
    }
    return dropAreas;
  }

  return (
    <S.Root>
      {props.dropAreas.length>0 && renderDropAreas()}
    </S.Root>
  );
};
  
export default DropAreaAddIn;